<template>
<v-row class="ml-6 pr-0 custom-white-bg">
 <div class="container mypadd">
  <div class="col-sm-12 pa-0">
  <div class="row offset-sm-5 offset-xs-1"  style="border-bottom:1px solid #ccc;">
   
    <div class=" col-xs-2 d-none d-sm-block col-sm-2  div-colcls  text-center">
     <!-- <h5>DamnN Bank </h5>
      <p class="custom-bamnn-bank-color" > $ {{ showamount}}</p>-->
    </div>
    <div class=" col-xs-2 col-sm-2 d-none d-sm-block div-colcls text-center">
      <!--<h5>PP Bank</h5>
      <p class="custom-pp-bank-color">$ {{showdaminamount}} </p> -->
    </div>
    <div class=" col-xs-2 col-sm-2 d-none d-sm-block text-center div-colcls">
    <!-- <h5>Kel</h5>
     <p class="custom-kel-color">{{showkelamount}}</p>-->
     <h5>Credit </h5>
      <p class="custom-bamnn-bank-color" > ${{showcreditbalance}}</p>
    </div>
      <div class="col-xs-3 col-sm-1 text-right custom-profile" style="padding-right:0px;">
                   <v-avatar size="40px">
                      <img alt="Avatar" :src="notimageimage" v-if="image === baseURL+'storage/1.1' || image === baseURL+'storage/.1'">
                      <img alt="Avatar" :src="image" v-else>
                    </v-avatar>
                   
    </div>
     <div class="text-left col-sm-2 col-xs-3 custom-profile" style="padding-left:5px;">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
         
          v-bind="attrs"
          v-on="on"
           style="background-color: #fff !important;
    border: red !important;
    color: #000;
"
        >
         <v-list-item-icon>
        {{name}}    <v-icon class="black--text" style="margin-top:-4px;">mdi-menu-down-outline</v-icon>
          </v-list-item-icon>
        </v-btn>
      </template>
      <v-list>
         <!---Payment-->  
           <v-list-item class="bank  d-lg-none d-xl-block" >
          <v-list-item-title>DamnN Bank <span class="showamount"> ( $ {{ showamount}} ) </span></v-list-item-title>
           </v-list-item>
            <v-list-item  class="bank d-lg-none d-xl-block">
          <v-list-item-title>PP Bank <span class="showamount"> ( $ {{showdaminamount}} ) </span> </v-list-item-title>
           </v-list-item>
            <v-list-item  class="bank d-lg-none d-xl-block">
          <v-list-item-title>Kel <span class="showamount">( {{showkelamount}} ) </span></v-list-item-title>
           </v-list-item>
         <!----Payment --------->
        <v-list-item link :to="{name: 'editprofile'}" >
          <v-list-item-title>
          <v-icon class="blue--text" >mdi-account-edit</v-icon>
            Edit Profile</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="{name: 'changepassword'}" >
          <v-list-item-title>
          <v-icon class="blue--text" >mdi-onepassword</v-icon>
            Change Password</v-list-item-title>
        </v-list-item>
         <v-list-item  class="logoutouter" link :to="{name: 'logout'}" >
            <v-icon  class="logoutlink"  >mdi-logout</v-icon>
        
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
    </div>
    
  </div>
</div>
</v-row>  
</template>

<script>
import { mapGetters } from "vuex";
//import { mapState } from 'vuex'

 export default{
     data(){
         return{
              hasImage: false,
            isImagePosition: true,
            notimageimage: require("@/assets/user.png"),
         };
     },
     computed:{
        ...mapGetters(
         {
           showamount : 'showamount',
           showkelamount : 'showkelamount',
           showdaminamount : 'showdaminamount',
           showcreditbalance: 'getCreditBalance' 
         }),
    // ...mapState({
    //    image:'avatar'
    //  }),
    image(){
      
       return this.$store.getters.getavatar;
    },
          baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }, 
             name() {
                return this.$store.getters.name;
              },
     },
     mounted() {
      this.getInbankBalance();
       this.getDamanBalance();
    },
    methods:{
       getInbankBalance() {
          this.$store.dispatch("retrieveInbankKelBalance").then(() => {
         });
      },
      getDamanBalance() {
          this.$store.dispatch("retrieveDammnbankBalance").then(() => {
           });
      },  
    }
 } 
</script>
 <style>
.custom-white-bg{
background-color:#fff !important;margin-right:-16px !important;
} 
.mypadd{padding: 12px !important;}
.custom-pa-0{padding: 0px !important;}
.custom-bamnn-bank-color{color:#E53935 !important;}
.custom-pp-bank-color{color:#03A9F4 !important;}
.custom-kel-color{color:#43A047 !important;}
h5{color:#424242 !important;}
.v-btn--is-elevated{box-shadow: none !important;}

 </style>
<style scoped>
.div-colcls {
  margin-left: 10px;
  background-color:#fff;
  padding:2px !important;
}



.logoutouter{border-top:1px solid #6cbcf4;padding: 5px;justify-content:center !important;}
.logoutlink{ background-color:rgb(245, 10, 10); color: #fff !important;}
.bank{background-color:#f8ce4b; color:#fff;font-size: 15px;border-bottom: 1px solid #6cbcf4;}
.showamount{color: #6cbcf4; font-weight: bold;}
@media (min-width:320px)  { /* smartphones, portrait iPhone, portrait 480x320 phones (Android) */
 .custom-profile{width:30% !important;}
}
@media (min-width:480px)  { /* smartphones, Android phones, landscape iPhone */ 
  .custom-profile{width:30% !important;}
}
</style>